export default {
  // Locales
  localeSwitch: {
    de: 'Deutsch',
    en: 'Englisch',
  },

  common: {
    noEntries: 'Keine Einträge vorhanden',
    pagination: {
      previous: 'zurück',
      next: 'weiter',
      info: 'Keine Einträge | 1 Eintrag | {start} - {end} von {totalItems} Einträgen'
    }
  },

  counts: {
    tags: 'No Tags | 1 Tag | {count} Tags',
    articles: 'No Articles | 1 Article | {count} Articles',
    comments : 'kein Kommentar | 1 Kommentar | {count} Kommentare',
    members: 'kein Mitglied | 1 Mitglied | {count} Mitglieder',
    recipients: 'No recipients | 1 Recipient | {count} Recipients',
    posts: 'kein Beitrag | 1 Beitrag | {count} Beiträge',
    new_posts: 'kein neuer Beitrag | 1 neuer Beitrag | {count} neue Beiträge',
    entries: 'kein Eintrag | 1 Eintrag | {count} Einträge',
    groups: 'keine Gruppen | 1 Gruppe | {count} Gruppen'
  },

  password: {
    hint: 'Ihr Passwort sollte mindestens 10 Zeichen lang sein und neben Buchstaben auch Zahlen und Sonderzeichen enthalten.',
    indicator: {
      percent_0: 'Unsicher',
      percent_25: 'Unsicher',
      percent_50: 'Noch immer nicht sicher genug',
      percent_75: 'Schon besser',
      percent_100: 'So ist es sicher!'
    }
  },

  // Pages
  p: {
    // Home
    home: {
      section: {
        demo: {
          message: {
            description: 'Lassen Sie sich in einer persönlichen Online-Demo erklären wie Foldaz funktioniert – natürlich kostenlos und unverbindlich.',
          },
          title: 'Demo vereinbaren und foldaz kennenlernen.',
          form: {
            successMsg: 'Vielen Dank!'
          }
        },
        guarantee: {
          message: {
            description: 'foldaz ist ein Software as a Service-Tool für professionelle Anwender. Wir beachten das europäische Datenschutzrecht, wir hosten ausschließlich auf deutschen Servern und wir erstellen keine Profile unserer Nutzer oder verkaufen Daten unserer Nutzer. foldaz ist somit auch für Großunternehmen compliant.',
          },
          title: 'Datensicherheit',
        },
        intro: {
          label: {
            demo: 'Demo anfragen',
            features: 'Mehr zu den Funktionen',
            signin: 'Zum Login',
          },
          message: {
            description: 'Chatten können viele Tools. Aber was ist mit den wirklichen Infos, die alle brauchen? Und wie lernt ein Team voneinader ganz nebenbei? Ganz einfach: mit Foldaz. Foldaz kanalsiert jede Art von Information, macht sie greifbar und handhabbar.',
            signin: 'Schon angemeldet?',
          },
          title: 'Alles im Griff mit Foldaz',
        },
        testimonials: {
          message: {
            description: 'Wir zeigen anoymisierte Beispiele für den praktischen Einsatz, da wir öffentlich keine Kundennamen kommunizieren',
          },
          item: [
            {
              name: 'Simon',
              position: 'PR-Berater',
              quote: '„In der PR muss ich mit stetig in neue Themen einarbeiten. Seit wir Foldaz in der Agentur verwenden, haben wir endlich einen Ort wo alles zusammen läuft - egal ob aus dem Web, vom Kunden oder von unseren Rechnern. Themenrecherche, das Screening der Medien, Konkurrenzbeobachtung - all das ist so viel effizienter und das ganze Team profitiert davon. Foldaz ist für mich zu einem unverzichtbaren Tool geworden.“',
              avatar: 'simon.png'
            },
            {
              name: 'Alan',
              position: 'Board Member',
              quote: '„Ich bin ständig unterwegs und sauge dabei viele Informationen auf, die ich irgendwo ablegen und strukturieren muss. Mit Foldaz ist das ganz einfach und vor allem kann auch mein Team direkt sehen, was ich wieder alles Neues entdeckt habe. Dinge, die ich anderen weitergeben möchte, kann ich außerdem schnell zusammenstellen und teilen. Das macht mir das Leben wirklich einfacher.“',
              avatar: 'simon.png'
            },
            {
              name: 'Georg',
              position: 'Startup Gründer',
              quote: '„Ich baue gerade mein Startup auf. Für mein Produkt und mein Marketing suche ich ständig nach Infos, die ich mit Foldaz sehr einfach festhalten und teilen kann und meine Co-Founder wissen so auch immer, woran ich gerade sitze. Ich finde es beruhigend, dass ich wirklich alles an einem Ort habe, wo ich es jederzeit finden und nutzen kann. So geht mir nichts mehr verloren und auch spontane Dinge lassen sich leicht festhalten.“',
              avatar: 'simon.png'
            },
            {
              name: 'Céline',
              position: 'Musikerin & Kulturschaffende',
              quote: '„Ich bin im Kulturbereich tätig und organisiere mit Partnern kleinere und größere musikalische Events. Meine Projektpartner sind meist weit verstreut und manchmal auch etwas chaotisch. Da ist es super, dass ich alle Infos gut strukturieren kann und auch den anderen jederzeit alles nötige zugänglich machen kann. Ohne Foldaz das wäre das unendlich viel anstrengender. “',
              avatar: 'bianca.png'
            },
          ],
          title: 'Wie Firmen foldaz einsetzen',
        },
        overview: {
          message: {
            anonym: 'Anonyme Zugriffsstatistiken',
            create: 'Erstellung eigener Inhalte per Texteditor',
            comment: 'Beiträge durch Nutzer kommentierbar',
            description: 'Die Kernfeatures in der Übersicht',
            embed: 'Einbetten von Video- und Audiodaten (bspw. YouTube, Vimeo, Soundcloud etc.)',
            import: 'Import von Web-Content mit wenigen Klicks (Text, Bild, Video)',
            newsletter: 'Newsletter und Dokumente mit wenigen Klicks erstellen ohne Layoutprobleme',
            roles: 'Verschiedene Zugangsrechte für Admin, Redaktion, Gast-Redakteur, Leser',
            upload: 'Upload von eigenen Dokumenten (bspw. Bilder, PDF, Word)',
          },
          title: 'Funktionen in der Übersicht',
        },
      }
    },
    // Clients
    clientPage: {
      navigation: {
        members : 'Mitglieder',
        tags: 'Tags',
        theme: 'Farbschema',
        settings: 'Konto',
        invitations: 'Einladungen',
      },
    },
    clientInvitations: {
      title: 'Einladungen'
    },
    clientMembersPage: {
      title: 'Mitglieder'
    },
    clientThemePage: {
      title: 'Farbschema anpassen',
      btnSave: 'Änderungen speichern',
      btnReset: 'Zurücksetzen',
      btnLoadDefaults: 'Standardwerte laden'
    },
    clientTagsPage: {
      title: 'Tags',
      form: {
        action: {
          submit: 'Speichern'
        }
      }
    },
    clientSettingsPage: {
      form: {
        action: {
          submit: 'Speichern',
        },
        label: {
          email_blacklist    : 'Blacklist',
          email_whitelist    : 'Whitelist',
          logoSVG            : 'SVG Logo',
          name               : 'Name',
          owner              : 'Owner',
          signup_enabled     : 'Registrierung',
          signup_enabled_hint: 'Registrierung ohne Einladung erlauben',
          theme              : 'Theme',
          workspace          : 'Workspace',
          external: 'Öffnungsverhalten',
          external_hint: 'Quellen URL öffnen',
          shareable: 'Teilen',
          shareable_hint: 'Teilen ist erlaubt',
          logo: 'SVG Logo',
          logo_placeholder: 'Keine Datei ausgewählt',
          email_signature: 'E-Mail Signatur'
        },
      },
      title: 'Konto Einstellungen',
    },
    // Contents
    contentPage: {
      form: {
        action: {
          submitComment: 'Senden',
        },
        placeholder: {
          writeComment: 'Kommentar schreiben',
        },
      },
      label: {
        author     : 'Autor',
        countries  : 'Länder',
        createdAt  : 'Eingestellt am…',
        priority   : 'Priorität',
        publishedAt: 'Veröffentlicht am…',
        share      : 'Share',
        source     : 'Quelle',
        tags       : 'Tags',
        user       : 'Eingestellt von…',
        views      : 'Besucher',
      },
      title: {
        comments : 'kein Kommentar | 1 Kommentar | {count} Kommentare',
        documents: 'Dokumente',
        meta     : 'Weiteres',
      },
    },
    // Folders
    foldersDetailPage: {
      message: {
        empty: 'Keine Einträge vorhanden',
      },
    },
    // Invitations
    confirmInvitationPage: {
      message: {
        success: 'Einladung erfolgreich bestätigt, das Passwort für die Anmeldung erhalten Sie per E-Mail.',
        error  : 'Einladung nicht mehr gültig oder wurde bereits bestätigt.',
      },
      title: 'Einladung bestätigen',
    },
    // Settings
    destroyProfileSettings: {
      form: {
        action: {
          submit: 'Konto löschen',
        },
        label: {
          currentPassword: 'Aktuelles Passwort',
        },
      },
      title: 'Konto löschen',
    },
    emailSettings: {
      form: {
        action: {
          submit: 'E-Mail Adresse ändern',
        },
        label: {
          password         : 'Aktuelles Passwort',
          email            : 'Neue E-Mail Adresse',
          emailConfirmation: 'Neue E-Mail Adresse wiederholen',
        },
      },
      title: 'E-Mail Adresse ändern',
    },
    passwordSettings: {
      form: {
        action: {
          submit: 'Passwort ändern',
        },
        label: {
          currentPassword     : 'Aktuelles Passwort',
          password            : 'Neues Passwort',
          passwordConfirmation: 'Passwort wiederholen',
        },
      },
      title: 'Passwort ändern',
    },
    profileSettings: {
      form: {
        action: {
          submit: 'Speichern',
        },
        labels: {
          firstName      : 'Vorname',
          jobtitle       : 'Funktion',
          lastName       : 'Nachname',
          salutation     : 'Anrede',
          interests: 'Interessen'
        },
      },
      title: 'Konto',
    },
    settingsPage: {
      title: 'Einstellungen',
      navigation: {
        close_profile: 'Konto löschen',
        email        : 'E-Mail Adresse',
        password     : 'Passwort',
        profile      : 'Konto',
      },
    },
    // Stream
    streamPage: {
      label: {
        loadingInProgress: 'loading ...',
        loadMoreContent  : 'mehr laden',
        newEntries       : 'kein neuer Beitrag | 1 neuer Beitrag | {count} neue Beiträge',
      },
      title: 'Stream',
    },
    // Teams
    teamMembersPage: {
      title: 'Mitglieder',
    },
    teamPage: {
      navigation: {
        settings: 'Einstellungen',
        members : 'Mitglieder',
      },
      title: 'Teams',
    },
    teamSettingsPage: {
      form: {
        action: {
          submit: 'Speichern',
        },
        label: {
          name: 'Name',
        },
      },
      title: 'Einstellungen',
    },
    teamsPage: {
      title: 'Teams',
    },
    // Auth
    confirmPasswordResetPage: {
      title: 'Neues Passwort setzen',
    },
    pageNotFound: {
      title: '404',
      message: {
        pageNotFound: 'Page not found',
      },
    },
    passwordResetPage: {
      title: 'Passwort zurücksetzen',
    },
    signInPage: {
      title: 'Anmelden',
    },
    signUpPage: {
      title: 'Registrieren',
    },
  },

  // Components
  c: {
    // App
    confirmModal: {
      form: {
        action: {
          confirm: 'Ok',
          cancel : 'Abbrechen',
        },
      },
    },
    // Demo Form
    demoForm: {
      form: {
        action: {
          submit: 'Absenden',
        },
        label: {
          company: 'Firmenname',
          name: 'Ansprechpartner',
          email: 'Mailadresse',
          phone: 'Telefon',
        },
        placeholder: {
          company: 'Firmenname',
          name: 'Ansprechpartner',
          email: 'Mailadresse',
          phone: 'Telefon',
        }
      },
    },
    // Auth
    newPasswordForm: {
      form: {
        action: {
          signin: 'Anmelden',
          submit: 'Passwort ändern',
        },
        label: {
          newPassword            : 'Neues Passwort',
          newPasswordConfirmation: 'Passwort wiederholen',
        },
      },
    },
    passwordResetForm: {
      form: {
        action: {
          signin: 'Anmelden',
          submit: 'Passwort zurücksetzen',
        },
        label: {
          email    : 'E-Mail',
          workspace: 'Workspace',
        },
      },
    },
    signInForm: {
      form: {
        action: {
          signup: 'Registrieren',
          submit: 'Anmelden',
        },
        label: {
          email        : 'E-Mail',
          password     : 'Passwort',
          passwordReset: 'Passwort vergessen?',
          workspace    : 'Workspace',
          hintFalse    : ' ',
          hintTrue     : ' '
        },
      },
    },
    signUpForm: {
      form: {
        action: {
          signup: 'Registrieren',
          submit: 'Anmelden',
        },
        label: {
          email                : 'E-Mail',
          password             : 'Passwort',
          password_confirmation: 'Passwort',
          workspace            : 'Workspace',
        },
      },
    },
    // Clients
    clientMember: {
      createdAt: 'Registriert am:',
      teams: 'Teams: {teamsCount}',
      label: {
        all: 'Alle Rollen',
        owner: 'Owner',
        admin: 'Admin',
        editor: 'Editor',
        reader: 'Reader',
        first_name: 'Name',
        email: 'E-Mail',
        created_at: 'Registiert am',
        memberships_count: 'Teams'
      },
    },
    // Contents
    contentControls: {
      navigation: {
        filter : 'Filter',
        members: 'Mitglieder',
        share  : 'Share',
      },
    },
    contentFilterDetails: {
      label: {
        countries       : 'Länder',
        createdAt       : 'Erstellt',
        publishedAt     : 'Veröffentlicht',
        priority        : 'Priorität',
        source          : 'Quelle',
        tags            : 'Tags',
      },
    },
    contentFilterForm: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Übernehmen',
        },
        label: {
          countries       : 'Länder',
          createdAtFrom   : 'Erstellt am… (ab)',
          createdAtUntil  : 'Erstellt am… (bis)',
          priority        : 'Priorität',
          publishedAtFrom : 'Veröffentlicht am… (ab)',
          publishedAtUntil: 'Veröffentlicht am… (bis)',
          source          : 'Quelle',
          tags            : 'Tags',
          external        : 'Öffnungsverhalten'
        },
        placeholder: {
          createdAtFrom   : 'DD.MM.YYYY',
          createdAtUntil  : 'DD.MM.YYYY',
          publishedAtFrom : 'DD.MM.YYYY',
          publishedAtUntil: 'DD.MM.YYYY',
        },
        options: {
          created_at: 'Erstellt am',
          published_at: 'Veröffentlicht am',
          comments_count: 'Kommentare',
          views: 'Aufrufe',
          asc: 'Aufsteigend',
          desc: 'Absteigend',
          high: 'Hoch',
          normal: 'Normal',
          with_source_url: 'Artikel öffnet externere Quelle',
          without_source_url: 'Artikel öffnet im System'
        }
      },
    },
    contentFilterOverlay: {
      title: 'Filter',
    },
    contentForm: {
      form: {
        label: {
          author      : 'Autor',
          countries   : 'Länder',
          countries_db   : 'Länder (Regionen bitte über Tags zuweisen)',
          priority    : 'Priorität',
          publishedAt : 'Veröffentlicht am…',
          selectFolder: 'Folder auswählen',
          source      : 'Quelle',
          sourceURL   : 'URL',
          tags        : 'Tags',
          title       : 'Artikel',
        },
        placeholder: {
          publishedAt: 'DD.MM.YYYY',
        },
      },
    },
    contentLayoutSwitch: {
      navigation: {
        gridView: 'GridView',
        listView: 'ListView',
      },
    },
    contentModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Publizieren',
        },
      },
      message: {
        fetchData: 'Ziehe Daten',
      },
    },
    contentCopyModal: {
      title: 'Artikel kopieren',
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Kopieren',
        },
        label: {
          folder: 'Kopieren nach',
        },
      },
    },
    contentShareModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Senden',
        },
        label: {
          recepient: 'Empfänger',
          tags     : 'Tags',
        },
      },
    },
    // Folders
    folder: {
      label: {
        entries: 'kein Eintrag | 1 Eintrag | {count} Einträge',
      },
    },
    folderMembersOverlay: {
      title: 'Mitglieder',
    },
    folderModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Folda erstellen | Speichern',
        },
        label: {
          description: 'Beschreibung des Folda',
          name       : 'Name des Folda',
          team       : 'Team',
          title      : 'Folda erstellen | Folda bearbeiten',
        },
      },
    },
    folderSettingsOverlay: {
      title: 'Einstellungen',
      form: {
        label: {
          name: 'Name des Folda',
          description: 'Beschreibung des Folda',
          exportEnabled: 'Automatischen Widget Export aktivieren',
          exportUrl: 'Export URL',
          exportUrlHint: 'Der Automatisch Export wird beim bearbeiten oder hinzufügen von Artikel in diesem Ordner ausgeführt. Eine URL ist erst vorhanden wenn ein Export durchgeführt wurde.'
        }
      }
    },
    // Forms
    documentsInput: {
      form: {
        label: {
          add: 'Dokument auswählen',
        },
      },
    },
    formWrap: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Senden',
        },
      },
    },
    textInput: {
      form: {
        action: {
          copyToClipboard: "Kopieren",
        },
      },
    },
    // Invitations
    invitationModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Senden',
        },
        label: {
          email_addresses: 'E-Mail Adressen eingeben (mehrere mit Komma)',
          role           : 'Rolle',
          role_hint      : 'Mitglieder haben Admin-Rechte',
        },
      },
      title: 'Mitglied(er) hinzufügen',
    },
    // Layout
    mainFooter: {
      navigation: {
        about: 'Über uns',
        contact: 'Kontakt',
        howToUse: 'How to use',
        imprint: 'Impressum',
        privacy: 'Datenschutz',
        tos: 'Nutzungsbedingungen',
        bookmarklet: 'Bookmarklet'
      },
      title: {
        about   : 'Foldaz',
        language: 'Sprache',
      },
    },
    mainNav: {
      navigation: {
        signin: 'Anmelden',
        signup: 'Registrieren',
      },
      dropdown: {
        client_settings: 'Client',
        user_settings: 'Einstellungen',
        logout: 'Logout'
      }
    },
    // Membership
    membership: {
      label: {
        owner: 'Owner',
      },
    },
    membershipModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Hinzufügen | Speichern',
        },
        label: {
          team: 'Team',
          role: 'Rolle',
        },
        hint: {
          role: 'User hat Admin-Rechte',
        },
      },
      title: 'Zum Team hinzufügen | Mitgliedschaft bearbeiten',
    },
    // Ownership
    ownership: {
      label: {
        owner: 'Owner',
      },
    },
    // Search
    searchBar: {
      form: {
        placeholder: {
          search: 'Suchbegriff eingeben',
        },
      },
      navigation: {
        filter: 'Filter',
        share : 'Share',
      },
    },
    searchFilterForm: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Übernehmen',
        },
        label: {
          countries       : 'Länder',
          createdAtFrom   : 'Erstellt am… (ab)',
          createdAtUntil  : 'Erstellt am… (bis)',
          priority        : 'Priorität',
          publishedAtFrom : 'Veröffentlicht am… (ab)',
          publishedAtUntil: 'Veröffentlicht am… (bis)',
          source          : 'Quelle',
          tags            : 'Tags',
        },
        placeholder: {
          createdAtFrom   : 'DD.MM.YYYY',
          createdAtUntil  : 'DD.MM.YYYY',
          publishedAtFrom : 'DD.MM.YYYY',
          publishedAtUntil: 'DD.MM.YYYY',
        },
      },
    },
    searchFilterOverlay: {
      title: 'Filter',
    },
    searchResult: {
      message: {
        noEntries: 'Keine Inhalte vorhanden.',
        entries: 'Eintrag | {count} Einträge',
      },
    },
    // Stream
    streamItem: {
      label: {
        createdAt: 'Erstellt am ',
        readMore: 'Weiterlesen',
      },
    },
    // Teams
    team: {
      label: {
        members: 'kein Mitglied | 1 Mitglied | {count} Mitglieder',
      },
    },
    teamMember: {
      label: {
        owner: 'Owner',
      },
    },
    teamModal: {
      form: {
        action: {
          cancel: 'Abbrechen',
          submit: 'Team erstellen | Speichern',
        },
        label: {
          name: 'Name des Teams',
        },
      },
      title: 'Team erstellen | Team bearbeiten',
    },
    teamWithFolders: {
      label: {
        folders: 'kein Folda | 1 Folda | {count} Foldaz',
      },
    },
    completeProfileOverlay: {
      title: 'Profil vervollständigen',
      btnSubmit: 'Fortfahren',
      btnLogout: 'Abmelden'
    },
    updatePasswordOverlay: {
      title: 'Neues Passwort setzen',
      form: {
        labels: {
          currentPassword: 'Aktuelles Passwort',
          password: 'Passwort',
          passwordConfirmation: 'Passwort bestätigen'
        }
      },
      btnSubmit: 'Fortfahren',
      btnLogout: 'Abmelden'
    },

    contentExportOverlay: {
      stepFormat: {
        title: 'Format',
        btnNext: 'Weiter zu den Artikeln',
        form: {
          label: {
            format: 'Format'
          },
          options: {
            html: 'HTML',
            pdf: 'PDF'
          }
        }
      },
      stepArticles: {
        title: 'Artikel',
        btnNext: 'Weiter zur Ausgabe'
      },
      stepOutput: {
        title: 'Ausgabe',
        btnClose: 'Schließen'
      }
    },

    mailingOverlay: {
      stepHistory: {
        title: 'History',
        no_entries: 'No entries available.',
        btnNew: 'Create new',
        showLatestNewsletter: 'Letzten Newsletter anzeigen'
      },
      stepTitle: {
        title: 'Title',
        btnNext: 'Continue to tags',
      },
      stepTags: {
        title: 'Tags',
        btnNext: 'Continue to articles',
      },
      stepArticles: {
        title: 'Articles',
        sortDropdown: {
          asc: 'Ascending',
          desc: 'Sescending'
        },
        selectDropdown: {
          selectall: 'Select all',
          deselectall: 'Deselect all'
        },
        groupedContentSelected: 'kein Artikel ausgewählt | 1 Artikel ausgewählt | {count} Artikel ausgewählt',
        btnNext: 'Continue to recipients',
        btnBack: 'Go back'
      },
      stepRecipients: {
        title: 'Recipients',
        selectDropdown: {
          selectall: 'Select all',
          deselectall: 'Deselect all'
        },
        btnNext: 'Continue to summary',
        btnBack: 'Go back'
      },
      stepSummary: {
        title: 'Summary',
        stats: {
          articles: 'Artikel | Artikel | Artikel',
          recipients: 'Empfänger | Empfänger | Empfänger',
          groups: 'Gruppen | Gruppe | Gruppen'
        },
        previewRecipients: 'Vorschau E-Mail Empfänger',
        notification: 'Message was sent successfully!',
        btnNext: 'Send now',
        btnPreview: 'Send preview',
        btnBack: 'Go back'
      },
      stepSuccess: {
        title: 'Messages sent',
        text: 'Your messages were sent. You may close this window now. We wish you a great day.',
        btnClose: 'Close window'
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/i18n/de.js